
import moment from 'moment-timezone'
import numeral from 'numeral'

import { numeralConfig } from './globalVars'
import 'moment/locale/tr'
moment.locale('tr')

if (numeral.locales.tr === undefined) { numeral.register('locale', 'tr', numeralConfig) }
numeral.locale('tr')

const DirectionUrl = coord => {
  if (coord) {
  // Detect type of device to prepare URL for map directions
    switch (true) {
      case (/ipad|iphone|ipod/i.test(navigator.userAgent.toLowerCase())):
        return `https://maps.google.com/?saddr=Current+Location&daddr=${coord.lat},${coord.lng}`
      case (/windows phone 7/i.test(navigator.userAgent.toLowerCase())):
        return `maps:${coord.lat},${coord.lng}`
      case (/windows phone 8/i.test(navigator.userAgent.toLowerCase())):
        return `ms-drive-to:?destination.latitude=${coord.lat}&destination.longitude=${coord.lng}`
      case (/android/i.test(navigator.userAgent.toLowerCase())):
        return `google.navigation:q=${coord.lat},${coord.lng}`
      case (/blackberry/i.test(navigator.userAgent.toLowerCase())):
        return `javascript:blackberry.launch.newMap({'nav_end':{'latitude':${coord.lat},'longitude':${coord.lng}}})`
      default:
        return `https://maps.google.com?daddr=loc:${coord.lat},${coord.lng}`
    }
  }
}

const isIOS = () => {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
}

const isObjEqual = (a, b) => { // Create arrays of property names
  const aProps = Object.getOwnPropertyNames(a)
  const bProps = Object.getOwnPropertyNames(b)

  if (aProps.length !== bProps.length) {
    return false
  }

  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i]

    if (a[propName] !== b[propName]) { return false }
  }
  return true
}
const guid = () => {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

const makeid = length => {
  let text       = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}
const zeroPad = (num, places) => String(num).padStart(places, '0')

const countDecimals = value => {
  const text = value.toString()
  if (text.indexOf('e-') > -1) {
    const [, trail] = text.split('e-')
    const deg       = parseInt(trail, 10)
    return deg
  }
  // count decimals for number in representation like "0.123456"
  if (Math.floor(value) !== value) {
    return value.toString().split('.')[1].length || 0
  }
  return 0
}

const s2v = str => {
  const translate_re = /[öüçğşıÖÜÇĞŞİ&]/g
  const translate    = {
    ö: 'o',
    ü: 'u',
    ç: 'c',
    ğ: 'g',
    ş: 's',
    ı: 'i',
    Ö: 'O',
    Ü: 'U',
    Ç: 'C',
    Ğ: 'G',
    Ş: 'S',
    İ: 'I',
    '&': ''
  }
  const strArr       = str.replace(translate_re, match => translate[match]).toLowerCase().split(' ')
  const arr2         = strArr.slice(1).map(s => s.charAt(0).toUpperCase() + s.slice(1))

  return strArr[0] + arr2.join('')
}
const s2e = str => {
  const translate_re = /[öüçğşıÖÜÇĞŞİ&]/g
  const translate    = {
    ö: 'o',
    ü: 'u',
    ç: 'c',
    ğ: 'g',
    ş: 's',
    ı: 'i',
    Ö: 'O',
    Ü: 'U',
    Ç: 'C',
    Ğ: 'G',
    Ş: 'S',
    İ: 'I',
    '&': ''
  }
  const strArr       = str.replace(translate_re, match => translate[match]).toLowerCase().split(' ')
  const arr2         = strArr.slice(1).map(s => s.charAt(0) + s.slice(1))

  return strArr[0] + arr2.join('')
}

const initNumeral = () => {
  if (numeral.locales.tr === undefined) { numeral.register('locale', 'tr', numeralConfig) }
  numeral.locale('tr')
}

const formatMoney = value => {
  return numeral(value).format('0,0[.]00 $')
}

const formatNumber = value => {
  return numeral(value).format('0.00')
}

const Reorder = (list, startIndex, endIndex) => {
  const result    = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const isNumber             = n => /^-?[\d.]+(?:e-?\d+)?$/.test(n)
const isInt                = n => Number(n) === n && n % 1 === 0
const isFloat              = n => Number(n) === n && n % 1 !== 0
const isEmpty              = (obj) => obj && Object.keys(obj).length === 0 && obj.constructor === Object
const isCurrentDateBetween = range => {
  if (!range) { return false } else {
    return moment().isBetween(moment(range[0]), moment(range[1]))
  }
}

const isLocalhost = Boolean((window?.location?.hostname || 'https://kolayyolla.app') === 'localhost' ||
    (window?.location?.hostname || 'https://kolayyolla.app') === '[::1]' ||
    (window?.location?.hostname || 'https://kolayyolla.app').match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

const colorShade = (col, amt) => {
  if (typeof (col) === 'string' && col !== '') {
    col = col.replace(/^#/, '')
    if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2]

    let [r, g, b] = col.match(/.{2}/g);
    ([r, g, b]     = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt])

    r = Math.max(Math.min(255, r), 0).toString(16)
    g = Math.max(Math.min(255, g), 0).toString(16)
    b = Math.max(Math.min(255, b), 0).toString(16)

    const rr = (r.length < 2 ? '0' : '') + r
    const gg = (g.length < 2 ? '0' : '') + g
    const bb = (b.length < 2 ? '0' : '') + b

    return `#${rr}${gg}${bb}`
  } else { return col }
}

const randomColor = (number) => {
  const hue = number * 137.508 // use golden angle approximation
  return `hsl(${hue},60%,65%)`
}

const b64DecodeUnicode = str => {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    let code = p.charCodeAt(0).toString(16).toUpperCase()
    if (code.length < 2) {
      code = '0' + code
    }
    return '%' + code
  }))
}

const GetTimeStamp = (fromDate, approveDate) => {
  const a           = approveDate ? moment(approveDate) : moment()
  const b           = moment(fromDate)
  const msDiffrence = moment.utc(a.diff(b))
  if (a.diff(b, 'hours') < 1) { return msDiffrence.format('mm:ss') } // -1000
  else if (a.diff(b, 'hours') < 5) { return b.toNow(true) }
}

const groupDeliveryAreas = (data, threshold = 1) => {
  return data.reduce((acc, cur, i, src) => {
    if (cur.minTotal - (src[i - 1] && src[i - 1].minTotal) <= threshold) {
      if (!Array.isArray(acc[acc.length - 1])) {
        acc[acc.length - 1] = [acc[acc.length - 1]]
      }
      acc[acc.length - 1].push(cur)
      return acc
    }
    acc.push(cur)
    return acc
  }, [])
    .reduce((acc, cur) => {
      if (Array.isArray(cur)) {
        let max  = 0
        let mode = null

        cur.reduce((a, c) => {
          a[c.minTotal] = (a[c.minTotal] || 0) + 1

          if (max < a[c.minTotal]) {
            max  = a[c.minTotal]
            mode = c.minTotal
          }
          return a
        }, {})
        acc.push(cur.map(c => { return { ...c, minTotal: mode } }))
      } else { acc.push(cur) }
      return acc
    }, [])
    .reduce((acc, cur) => Array.isArray(cur) ? [...acc, ...cur] : [...acc, cur], [])
}
const arrayUnique = (array) => {
  const a = array.concat()
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) { a.splice(j--, 1) }
    }
  }

  return a
}

const roundHalf = (n) => {
  return parseFloat((Math.round(n * 2) / 2).toFixed(1))
}

// TODO duplicated function from backend
const checkIfVenueIsInWorkingHours = (workingHours, time) => {
  if (!workingHours) return false
  if (!Array.isArray(workingHours)) return false
  if (workingHours.length == 0) return false
  let isWithinWorkingHours

  const timeToCheck = time ? moment(time).tz('Europe/Istanbul') : moment.tz('Europe/Istanbul')
  const yesterday   = workingHours.find(wh => wh.key === moment(timeToCheck).add(-1, 'day').isoWeekday())

  const yesterdayFrom = moment(timeToCheck).add(-1, 'day').set({ hour: yesterday.from.h, minute: yesterday.from.m, second: 0 })
  const yesterdayTo   = moment(timeToCheck).add(-1, 'day').set({ hour: yesterday.to.h, minute: yesterday.to.m, second: 0 })

  if (yesterdayTo.isBefore(yesterdayFrom)) {
    yesterdayTo.add(1, 'day')
  }

  isWithinWorkingHours = moment(timeToCheck).isBetween(yesterdayFrom, yesterdayTo)

  if (isWithinWorkingHours) {
    if (yesterday.isClosed) { return false } else { return isWithinWorkingHours }
  }

  const workingDay = workingHours.find(wh => wh.key === moment(timeToCheck).isoWeekday())
  const fromDate   = moment(timeToCheck).set({ hour: workingDay.from.h, minute: workingDay.from.m, second: 0 })
  const toDate     = moment(timeToCheck).set({ hour: workingDay.to.h, minute: workingDay.to.m, second: 0 })

  if (toDate.isBefore(fromDate)) {
    if (moment(timeToCheck).hour() < toDate.hour) { fromDate.add(-1, 'day') } else { toDate.add(1, 'day') }
  }

  isWithinWorkingHours = moment(timeToCheck).isBetween(fromDate, toDate)

  if (workingDay.isClosed) { return false } else { return isWithinWorkingHours }
}

export {
  DirectionUrl,
  countDecimals,
  isObjEqual,
  isNumber,
  isInt,
  isFloat,
  isEmpty,
  isIOS,
  isCurrentDateBetween,
  guid,
  makeid,
  zeroPad,
  s2v,
  s2e,
  initNumeral,
  formatMoney,
  formatNumber,
  Reorder,
  toTitleCase,
  isLocalhost,
  randomColor,
  colorShade,
  b64DecodeUnicode,
  GetTimeStamp,
  groupDeliveryAreas,
  arrayUnique,
  checkIfVenueIsInWorkingHours,
  roundHalf
}
